module.exports = Em.Handlebars.compile("<div class=\"notch\"></div>\n<div class=\"message\" data-cy=\"tooltip-message\"></div>");